// import 'whatwg-fetch'; // fetch polyfill
// import 'babel-polyfill';
// import 'nodelist-foreach-polyfill';
// import 'element-closest-polyfill';
// import 'mdn-polyfills/Node.prototype.append';

require('./analytics.js');
require('./nav.js');
require('./supernav.js');
require('console-polyfill');
require('picturefill');
require('./popups');
require('./dialog');

// set the document.domain to work with cross site scripting like Pardot
window.originalDomain = document.domain;
if (document.domain.match(/diodes\.com$/)) {
    try {
        document.domain = 'diodes.com';
    } catch (error) {
        console.error(error); // eslint-disable-line no-console
    }
}

// conditionally load additional JS
// js loaded via the import function (as opposed to the import statement)
// get loaded at runtime. You can wrap them in conditional statements
// to keep them from loading unless desired

// view-all
if (document.querySelector('[data-view-all]')) {
    import(/* webpackChunkName: "view-all" */ './view-all');
}

// product-collection
if (document.querySelector('[data-product-collection]')) {
    import(/* webpackChunkName: "product-collection" */ './product-collection').then();
}

// svg-injector-helper (doesn't work well with IE)
if (document.querySelector('[data-svg-inject]') && !document.querySelector('html.ie')) {
    import(/* webpackChunkName: "svg-injector-helper" */ './svg-injector-helper').then();
}

if (document.querySelector('[data-block-diagram]')) {
    import(/* webpackChunkName: "block-diagram" */ './block-diagram').then();
}

// autocomplete-helper
if (document.querySelector('[data-autocomplete]')) {
    import(/* webpackChunkName: "autocomplete-helper" */ './autocomplete-helper').then();
}

// show-if
if (document.querySelector('[data-show-if]')) {
    import(/* webpackChunkName: "show-if" */ './show-if').then();
}

// ajax-inject
if (document.querySelector('[data-ajax-inject]')) {
    //  IntersectionObserver Polyfill if needed
    if (!('IntersectionObserver' in window)) {
        import(/* webpackChunkName: "intersection-observer" */ 'intersection-observer').then(() => {
            import(/* webpackChunkName: "ajax-inject" */ './ajax-inject').then();
        });
    } else {
        import(/* webpackChunkName: "ajax-inject" */ './ajax-inject').then();
    }
}

// tabset (newer tabs)
if (document.querySelector('[data-tabset]')) {
    import(/* webpackChunkName: "tabset" */ './tabset').then();
}

// tabs
if (document.querySelector('[data-tab-group]')) {
    import(/* webpackChunkName: "tabs" */ './tabs').then();
}

// // tree
// if (document.querySelector('[data-tree]')) {
//     import(/* webpackChunkName: "tree" */ './tree').then();
// }

// expiring-link
if (document.querySelector('[data-expiring-link]')) {
    import(/* webpackChunkName: "expiring-link" */ './expiring-link').then();
}

// watch-part
if (document.querySelector('[data-watch-part]')) {
    import(/* webpackChunkName: "watch-part" */ './watch-part').then();
}

// world-map
if (document.querySelector('[data-world-map]')) {
    import(/* webpackChunkName: "world-map" */ './world-map').then();
}

// slideshow
if (document.querySelector('[data-swiper-id]')) {
    import(/* webpackChunkName: "swiper" */ './swiper').then();
}

// slider
if (document.querySelector('[data-slider]')) {
    import(/* webpackChunkName: "slider" */ './slider').then();
}

// jump-link-dropdown
if (document.querySelector('[data-jump-link-dropdown]')) {
    import(/* webpackChunkName: "jump-link-dropdown" */ './jump-link-dropdown').then();
}

// data-masonry
if (document.querySelector('[data-masonry]')) {
    import(/* webpackChunkName: "masonry" */ './masonry').then();
}

// product-collection
if (document.querySelector('[data-product-collection]')) {
    import(/* webpackChunkName: "product-collection" */ './product-collection').then();
}

// accordion
if (document.querySelector('[data-accordion]')) {
    import(/* webpackChunkName: "accordion" */ './accordion').then();
}

// table-accordion
if (document.querySelector('[data-table-accordion]') || document.querySelector('[data-stock-product]')) {
    import(/* webpackChunkName: "table-accordion" */ './table-accordion').then();
}

// stock-search
if (document.querySelector('[data-stock-search]')) {
    import(/* webpackChunkName: "stock-search" */ './stock-search').then();
}

// search-slash
if (document.querySelector('#SearchForm_q')) {
    import(/* webpackChunkName: "search-slash" */ './search-slash').then();
}

// qr-code
if (document.querySelector('[data-qr-code]')) {
    import(/* webpackChunkName: "qr-code" */ './qr-code').then();
}

// stock-product
if (document.querySelector('[data-stock-product]')) {
    import(/* webpackChunkName: "stock-product" */ './stock-product').then();
}

// tiny-accordion
if (document.querySelector('[data-tiny-accordion-link]')) {
    import(/* webpackChunkName: "tiny-accordion" */ './tiny-accordion').then();
}

// product-index
if (document.querySelector('[data-product-index]')) {
    import(/* webpackChunkName: "product-index" */ './product-index').then();
}

// year-form
if (document.querySelector('[data-year-form]')) {
    import(/* webpackChunkName: "year-form" */ './year-form').then();
}

// submit-onchange
if (document.querySelector('[data-submit-onchange]')) {
    import(/* webpackChunkName: "submit-onchange" */ './submit-onchange').then();
}

// search-results-filters
if (document.querySelector('.SearchForm__filters input')) {
    import(/* webpackChunkName: "search-results-filters" */ './search-results-filters').then();
}

// search-results-filters
if (document.querySelector('.confirmedpassword')) {
    import(/* webpackChunkName: "confirmedpassword" */ './confirmedpassword').then();
}

// filterable
if (document.querySelector('[data-filter-list]')) {
    import(/* webpackChunkName: "filterable" */ './filterable').then();
}

// calculator
if (document.querySelector('[data-calculator]')) {
    import(/* webpackChunkName: "calculator" */ './calculator').then();
}

// magcalc
if (document.querySelector('[data-calculator-magcalc]')) {
    import(/* webpackChunkName: "magcalc" */ './calculator-magcalc').then();
}

// svglinks
if (document.querySelector('[data-svglinks]')) {
    import(/* webpackChunkName: "svglinks" */ './svglinks').then();
}

// gallery
if (document.querySelector('[data-gallery] [data-gallery-item]')) {
    import(/* webpackChunkName: "gallery" */ './gallery.js').then();
}

// zoomable
if (document.querySelector('[data-zoomable]')) {
    import(/* webpackChunkName: "zoomable" */ './zoomable.js').then();
}

// up-arrow && feedback
if (document.querySelector('[data-page-action-btns]')) {
    import(/* webpackChunkName: "up-arrow" */ './up-arrow').then();
    import(/* webpackChunkName: "feedback" */ './feedback').then();
}

// navscroll
if (document.querySelector('[data-navscroll]')) {
    import(/* webpackChunkName: "navscroll" */ './navscroll').then();
}
